(function () {
  var instances = new WeakMap();

  var setOpenItem = function (items, targetItem) {
    items.forEach(function (item) {
      var isOpen = item === targetItem;
      var trigger = item.querySelector('.custom-reviews-section__trigger');
      var panel = item.querySelector('.custom-reviews-section__panel');

      item.setAttribute('data-open', isOpen ? 'true' : 'false');

      if (trigger) {
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }

      if (panel) {
        panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      }
    });
  };

  var init = function (section) {
    var accordion = section.querySelector('[data-custom-reviews-accordion]');

    if (!accordion) {
      return null;
    }

    var items = accordion.querySelectorAll('.custom-reviews-section__item');
    var triggers = accordion.querySelectorAll('.custom-reviews-section__trigger');

    if (!items.length || !triggers.length) {
      return null;
    }

    var onClick = function (event) {
      var trigger = event.currentTarget;
      var item = trigger.closest('.custom-reviews-section__item');

      if (!item) {
        return;
      }

      setOpenItem(items, item);
    };

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', onClick);
    });

    return {
      destroy: function () {
        triggers.forEach(function (trigger) {
          trigger.removeEventListener('click', onClick);
        });
      },
    };
  };

  var destroy = function (section) {
    var instance = instances.get(section);

    if (instance) {
      instance.destroy();
      instances.delete(section);
    }
  };

  var initAll = function (scope) {
    var container = scope || document;

    container.querySelectorAll('[data-custom-reviews-section]').forEach(function (section) {
      destroy(section);
      var instance = init(section);

      if (instance) {
        instances.set(section, instance);
      }
    });
  };

  var destroyAll = function (scope) {
    var container = scope || document;

    container.querySelectorAll('[data-custom-reviews-section]').forEach(function (section) {
      destroy(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });
})();
